import React, { useEffect, useState } from 'react';
import { Container } from './BrokenImage.styles';

interface IBrokenImage extends React.ImgHTMLAttributes<HTMLImageElement> {
  src?: string;
  brokenSrc: React.ReactNode;
}

export const BrokenImageEnhanced = ({
  brokenSrc,
  src,
  ...rest
}: IBrokenImage) => {
  const [isError, setIsError] = useState(!src);
  const [_src, setSrc] = useState(src);
  const handleError = () => {
    setIsError(true);
  };

  useEffect(() => {
    if (src !== _src) {
      setIsError(false);
      setSrc(src);
    }
  }, [src]);

  let imgSrc = _src;

  if (typeof brokenSrc === 'string' && isError) {
    imgSrc = brokenSrc;
  }

  if (typeof brokenSrc !== 'string' && isError) {
    return <>{brokenSrc}</>;
  }
  return <Container src={imgSrc} {...rest} onError={handleError} />;
};
